// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { ConfigProvider, Button, Tooltip, Alert, Progress } from 'antd';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import { YModal, YTable, YFilter, YIcon } from '@ywfe/ywd';
import { YFilterProps } from '@ywfe/ywd/lib/filter/filter.interface';

import { useGetAPI34034, API34034Res, useGetAPI22549 } from '../generated/api';
import { NavIconItemStyle } from './styles';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
let onReloadExportCenter: (reload?: boolean) => void;

export const ExportCenter: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [online, setLine] = useState(true);
  const [num, setNum] = useState(0);
  const { fetchAPI34034Data } = useGetAPI34034();
  const { fetchAPI22549Data } = useGetAPI22549();

  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      typeof window.showBaseExport !== 'function'
    ) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      window.showBaseExport = (): void => {
        setVisible(true);
      };
    }

    // 自动打开导出记录
    if (typeof window !== undefined && window.location.search.includes('autoOpen=EXPORT_RECORD') && !window.location.href.includes('login')) {
      // @ts-ignore
      setVisible(true);
    }
  }, []);

  useEffect(() => {
    if (window.location.href.includes('login')) {
      setLine(false);
    } else {
      setLine(true);
    }
  }, []);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (num > 0 && num < 40) {
      const clear = setTimeout(() => {
        onReloadExportCenter();
      }, 5000);
      return (): void => {
        clearTimeout(clear);
      };
    }
  }, [num]);

  const stop = (recordId: string): void => {
    YModal.confirm({
      title: '提示',
      content: '确认要停止嘛？',
      onOk: async () => {
        const res = await fetchAPI22549Data({ recordId });
        if (res) {
          // eslint-disable-next-line @typescript-eslint/no-unused-expressions
          res && onReloadExportCenter(false);
        }
      },
    });
  };

  const filterConfig: YFilterProps = {
    labelStyle: { width: 100 },
    config: [
      {
        type: 'DatePickerLine',
        apiParam: 'times',
        label: '创建时间',
        originalProps: {
          allowClear: true,
          showTime: true,
          placeholder: ['开始时间', '结束时间'],
          format: 'YYYY-MM-DD HH:mm:ss',
        },
      },
    ],
    defaultTableParams: {
      pageSize: 20,
    },
    onReload: (reload?: any) => {
      onReloadExportCenter = reload;
    },
    onAfterRequest: (data: any) => {
      if (data && data.list && Array.isArray(data.list)) {
        const is = data.list.some(({ showExportStatus }: { showExportStatus: string }) => showExportStatus === 'EXPORTING');
        if (is) {
          setNum(num + 1);
        }
      }
    },
    formBottomExtraContent: (): React.ReactNode => <Alert message="若任意一条数据下载进度未达到100%，数据将每5s刷新一次！" type="info" />,
    request: (values: any): Promise<API34034Res> => {
      const { times = [], ...rest } = values;
      return fetchAPI34034Data({
        createdAtStart: times[0],
        createdAtEnd: times[1],
        ...rest,
      });
    },
  };

  const columns = [
    {
      title: '项目名称',
      dataIndex: 'projectName',
    },
    {
      title: '文件名',
      dataIndex: 'fileName',
      ellipsis: {
        showTitle: false,
      },
      render: (fileName: string): React.ReactNode => (
        <Tooltip placement="top" title={fileName}>
          {fileName}
        </Tooltip>
      ),
    },
    {
      title: '状态',
      dataIndex: 'exportStatusStr',
      render: (status: string, { showExportStatus }: { showExportStatus: string }): React.ReactNode => (
        <span
          style={{
            color: showExportStatus === 'STOPPED' ? 'red' : '#333333',
          }}
        >
          {status}
        </span>
      ),
    },
    {
      title: '进度',
      dataIndex: 'processPercent',
      render: (percent: string, { showExportStatus }: { showExportStatus: string }): React.ReactNode =>
        showExportStatus === 'EXPORTING' ? (
          <div style={{ width: '80%', margin: '0 auto' }}>
            <Progress strokeColor="" size="small" percent={Number(percent)} status="active" />
          </div>
        ) : (
          <span>{`${percent}%`}</span>
        ),
    },
    {
      title: '创建时间',
      dataIndex: 'startTime',
    },
    {
      title: '完成时间',
      dataIndex: 'endTime',
    },
    {
      title: '操作人',
      dataIndex: 'doExportUserName',
    },
    {
      title: '操作',
      dataIndex: 'operation',
      render: (
        _: unknown,
        { downloadUrl, showExportStatus, recordingId }: { downloadUrl: string; showExportStatus: string; recordingId: string },
      ): React.ReactNode => (
        <>
          <Button
            type="link"
            disabled={['STOPPED', 'EXPORTING'].includes(showExportStatus)}
            onClick={(): void => {
              if (downloadUrl) {
                window.open(downloadUrl);
              }
            }}
          >
            下载
          </Button>
          {showExportStatus === 'EXPORTING' && (
            <Button
              danger
              onClick={(): void => {
                stop(recordingId);
              }}
              type="link"
            >
              停止
            </Button>
          )}
        </>
      ),
    },
  ];

  return (
    <NavIconItemStyle>
      {/* {online && (
        <div className="entry" onClick={() => setVisible(true)}>
          <YIcon name="ywcloudIcondaochu" size="20px" />
          <span className="name">导出记录</span>
        </div>
      )} */}
      {/* <Button
        type="link"
        onClick={(): void => {
          setVisible(true);
        }}
      >
        {
          online && (
            <>导出</>
          )
        }
      </Button> */}
      <YModal
        title="导出"
        size="fullScreen"
        visible={visible}
        footer={null}
        onCancel={(): void => {
          setVisible(false);
        }}
      >
        <ConfigProvider locale={zh_CN}>
          <YFilter {...filterConfig}>
            <YTable columns={columns} size="small" bordered />
          </YFilter>
        </ConfigProvider>
      </YModal>
    </NavIconItemStyle>
  );
};
